import { ChevronDown, LogOut } from 'lucide-react';
import { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { logoutUser } from '../../services/authService';

const UserMenu = () => {
  const navigate = useNavigate();

  const { logout } = useAuth();

  const [open, setOpen] = useState(false);

  const handleLogout = async () => {
    setOpen(false);

    try {
      await logoutUser();
    } catch (error) {
      // Local logout must still complete when the server session has already
      // expired or the logout request cannot be completed.
      console.error('Server logout failed:', error);
    } finally {
      logout();
      navigate('/', { replace: true });
    }
  };

  return (
    <>
      <button className="flex items-center gap-2 border rounded-xl px-3 py-2" onClick={() => setOpen(!open)}>
        <div className="w-8 h-8 rounded-full bg-red-400" />

        <ChevronDown size={16} />
      </button>

      {open && (
        <div className="absolute right-0 mt-2 w-44 bg-white border border-gray-200 rounded-lg shadow-lg z-50">
          <button
            onClick={handleLogout}
            className="flex items-center gap-2 w-full px-4 py-3 text-sm text-red-600 hover:bg-red-50 rounded-lg"
          >
            <LogOut size={16} />
            Logout
          </button>
        </div>
      )}
    </>
  );
};

export default UserMenu;
